import checkSubscription from '@/services/check-subscription';

export default async (to, from, next) => {
  try {
    const res = await checkSubscription(to.params.hash);
    const {
      name,
      price,
      discounted_price: discountedPrice,
      has_service_additionals: hasServiceAdditionals,
      user,
      service_name: serviceName,
      require_self: requireSelf,
      is_telemedicina_sharecare_familiar: isTelemedicinaSharecareFamiliar,
      is_telemedicina_sharecare_individual: isTelemedicinaSharecareIndividual,
      environment
    } = res.data.data;

    sessionStorage.setItem('name', name);
    sessionStorage.setItem('price', price);
    sessionStorage.setItem('discounted_price', discountedPrice);
    sessionStorage.setItem('has_service_additionals', hasServiceAdditionals);
    sessionStorage.setItem('user', JSON.stringify(user));
    sessionStorage.setItem('service_name', serviceName);
    sessionStorage.setItem('require_self', requireSelf);
    sessionStorage.setItem('isTelemedicinaSharecareIndividual', isTelemedicinaSharecareIndividual);
    sessionStorage.setItem('isTelemedicinaSharecareFamiliar', isTelemedicinaSharecareFamiliar);
    sessionStorage.setItem('env', environment);

    next();
  } catch (error) {
    sessionStorage.setItem('error_reason', error.message);
    next({ name: 'subscription-error' });
  }
};
